import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

/* ================= DATA ================= */
const DEFAULT_TRENDING_GAMES = [
  { id: 1, title: "Katana Fruits", image: "/assets/gamescard/fruit-ninja.png", link: "http://ghanagameium.com/katana-fruits/" },
  { id: 2, title: "Water Craft", image: "/assets/gamescard/watercraft.png", link: "http://ghanagameium.com/watercraft-rush/" },
  { id: 3, title: "Penalty kicks", image: "/assets/gamescard/penaltykicks.png", link: "http://ghanagameium.com/penalty-kicks/" },
  { id: 4, title: "Duck Shooter", image: "/assets/gamescard/duck-shooter.png", link: "http://ghanagameium.com/duck-shooter/" },
  { id: 5, title: "Ultimate Swish", image: "/assets/gamescard/ultimate-swish.png", link: "http://ghanagameium.com/ultimate-swish/" },
  { id: 6, title: "Marble Blast", image: "/assets/gamescard/marbleblast.png", link: "http://ghanagameium.com/marbleblast/" },
];

const Trending = () => {
  const navigate = useNavigate();
  
const handleGameClick = (game) => {
  const isSubscribed = localStorage.getItem("isSubscribed") === "true";

  if (!isSubscribed) {
    Swal.fire({
      title: "🚫 Subscription Required",
      text: "Please subscribe to play games",
      icon: "warning",
      confirmButtonColor: "#ff003c",
      confirmButtonText: "Go to Subscribe",
    }).then((result) => {
      if (result.isConfirmed) {
        navigate("/signin");
      }
    });
    return;
  }

  window.open(game.link, "_self");
};

  return (
    <div className="relative overflow-hidden mt-5">

      {/* 🔥 LIGHT CIRCLE EFFECT (NO BACKGROUND CHANGE) */}
      <div className="absolute left-[-200px] top-[0px] w-[400px] h-[400px] rounded-full 
      bg-gradient-to-br from-[#ff003c] to-[#6a00ff] 
      opacity-10 blur-[100px] pointer-events-none"></div>

      <div className="absolute right-[-150px] bottom-[0px] w-[350px] h-[350px] rounded-full 
      bg-gradient-to-tr from-[#ff003c] to-[#6a00ff] 
      opacity-10 blur-[120px] pointer-events-none"></div>

      {/* ================= CONTENT ================= */}
      <div className="relative z-10 w-full py-12 px-4">
        <div className="max-w-6xl mx-auto">

          {/* HEADER */}
          <div className="flex justify-between items-center mb-10">
            
            <h2 className="text-white text-3xl font-bold">
              <span className="text-[#ff003c]">Trending</span> Games
            </h2>

            <div className="flex gap-3">
              
              <button
                onClick={() => navigate("/games")}
                className="px-5 py-2 rounded-lg text-white font-semibold 
                bg-gradient-to-r from-[#ff003c] to-[#6a00ff]
                hover:scale-105 transition-all duration-300"
              >
                View All
              </button>

              <button className="swiper-button-prev-trending w-10 h-10 rounded-lg flex items-center justify-center 
              bg-[#1f1f35] hover:bg-[#ff003c] transition-all duration-300">
                <IoIosArrowBack className="text-white" />
              </button>

              <button className="swiper-button-next-trending w-10 h-10 rounded-lg flex items-center justify-center 
              bg-[#1f1f35] hover:bg-[#ff003c] transition-all duration-300">
                <IoIosArrowForward className="text-white" />
              </button>

            </div>
          </div>

          {/* SLIDER */}
          <Swiper
            modules={[Navigation, Autoplay]}
            navigation={{
              prevEl: ".swiper-button-prev-trending",
              nextEl: ".swiper-button-next-trending",
            }}
            autoplay={{ delay: 3500, disableOnInteraction: false }}
            loop
            spaceBetween={20}
            breakpoints={{
              0: { slidesPerView: 2 },
              640: { slidesPerView: 3 },
              1024: { slidesPerView: 4 },
              1280: { slidesPerView: 5 },
            }}
          >
            {DEFAULT_TRENDING_GAMES.map((game) => (
              <SwiperSlide key={game.id}>
                <div
                  onClick={() => handleGameClick(game)}
                  className="group cursor-pointer"
                >
                  
                  <div className="aspect-square w-full rounded-2xl overflow-hidden 
                  border border-[#ff003c]/20 
                  shadow-[0_10px_20px_rgba(255,0,60,0.1)]
                  group-hover:border-[#ff003c] 
                  group-hover:shadow-[0_0_20px_rgba(255,0,60,0.4)]
                  transition-all duration-300">

                    <img
                      src={game.image}
                      alt={game.title}
                      className="w-full h-full object-fill transition-transform duration-500 group-hover:scale-105"
                    />
                  </div>

                  <h3 className="mt-4 text-center text-white text-lg font-semibold group-hover:text-[#ff003c] transition">
                    {game.title}
                  </h3>

                </div>
              </SwiperSlide>
            ))}
          </Swiper>

        </div>
      </div>
    </div>
  );
};

export default Trending;